angular.module('unergie.main')
.filter('invoiceDownloadLink', () => {
    const filter = function (value, id_account) {
        if (id_account) {
            return `/api-user/documents/${id_account}/type/invoices?filename=${encodeURIComponent(value)}`
        }
        return `/api-user/documents/invoices/filename/${value}`
    }

    return filter
})
